<template>
  <el-footer class="footer">
    <router-link to="/" class="footer__link footer__link--more">
      О проекте
    </router-link>
    <ul class="footer__socials">
      <li>
        <a href="#">
          <svg-icon name="facebook" />
        </a>
      </li>
      <li>
        <a href="#">
          <svg-icon name="vk" />
        </a>
      </li>
      <li>
        <a href="#">
          <svg-icon name="instagram" />
        </a>
      </li>
      <li>
        <a href="#">
          <svg-icon name="twitter" />
        </a>
      </li>
    </ul>
    <ul class="footer__data">
      <li>
        <a href="#" class="footer__link">
          +7 (499) 110-37-41
        </a>
      </li>
      <li class="footer__link">м. Арбатская</li>
      <li class="footer__link">Мерзляковский переулок 13/3</li>
    </ul>
    <svg-icon name="logo-full" class="footer__logo" />
  </el-footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style scoped lang="scss">
.footer {
  margin: 24px 192px;
  background: $white;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  box-shadow: 0 4px 20px rgba($mine-shaft, 0.05);
  border-radius: 16px;
  padding: 32px 82px 20px;
  z-index: 12;
  min-height: 124px;

  @include xl-and-down {
    margin: 24px 80px;
  }

  @include lg-and-down {
    margin: 24px;
    padding: 32px 32px 20px;
  }

  @include md-and-down {
    flex-direction: column;
    align-items: center;
    justify-content: center;

    &__data {
      text-align: center;
    }
  }

  @include sm-and-down {
  }

  &__link {
    font-weight: bold;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.35px;
    color: $luchmara;
    transition: 0.3s;

    &:hover {
      color: rgba($luchmara, 0.7);
    }

    @include md-and-down {
      font-size: 14px;
    }
  }

  &__socials {
    display: flex;

    @include md-and-down {
      margin: 24px 0;
    }

    a {
      opacity: 0.6;
      transition: 0.3s;

      &:hover {
        opacity: 1;
      }

      svg {
        width: 24px;
        height: 24px;
      }
    }

    li:not(:first-of-type) {
      margin-left: 24px;
    }
  }

  &__logo {
    width: 175px;
    height: 48px;

    @include md-and-down {
      margin-top: 24px;
    }
  }
}
</style>
